<template>
  <div class="wrapper">
    <div  v-for="(item , index) of WarnInfoData" :key="index">
      <div class="effective">
        <!-- 左半部分 -->
        <div class="left-effective">
          <div class="">
            <div class="title-effective" style="min-width: 98px;">
              产线名称：
            </div>
            <div class="context">
              {{item.InvName}}
            </div>
          </div>
          <div class="border-context">
            <div class="title-effective" style="min-width: 98px;">
              规格型号：
            </div>
            <div class="context">
              {{item.InvAddCode}}
            </div>
          </div>
          <div class="border-context">
            <div class="title-effective" style="min-width: 98px;">
              对应发票号：
            </div>
            <div class="context">
              {{item.InvoiceNo}}
            </div>
          </div>
          <div class="border-context">
            <div class="title-effective" style="min-width: 83px;">
              预警含税单价：
            </div>
            <div class="context">
              {{item.TaxUnitPrice}}
            </div>
          </div>
        </div>
        <!--右半部分-->
        <div class="right-effective">
          <div class="">
            <div class="title-effective" style="min-width: 98px;">
              产品线：
            </div>
            <div class="context">
              {{item.InvClassName}}
            </div>
          </div>
          <div class="border-context">
            <div class="title-effective" style="min-width: 98px;">
              发票医院名称：
            </div>
            <div class="context">
              {{item.TerminalHPName}}
            </div>
          </div>
          <!-- <div class="border-context">
          <div class="title-effective" style="min-width: 98px;">
            发票医院名称：
          </div>
          <div class="context">
            康美雅泰医疗器械有限公司
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 83px;">
            预警含税单价：
          </div>
          <div class="context">
            500.00
          </div>
        </div> -->
        </div>
      </div>
      <div class="line">

      </div>
      <div class="reject-effective">
        <img src="@/assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
        {{item.WarningText}}
      </div>
    </div>

  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: { CommonuploadEnclosure },
  props: {
    WarnInfoData: {
      type: undefined
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>